import {useDispatch, useSelector, type TypedUseSelectorHook} from 'react-redux';
import type {AppDispatch, RootState} from './index';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
